import * as types from "../actions/actionTypes";
import initialState from "./initialState";


export default function routeCreatorStateReducer(state = initialState.routeCreatorState, action) {
    switch (action.type) {
        case types.UPDATE_DRAFTROUTE_MAPTYPE:
            return {
                ...state,
                mapType: action.mapType
            };
        case types.UPDATE_DRAFTROUTE_ZOOM:
            return {
                ...state,
                zoom: action.zoom
            };
        case types.UPDATE_DRAFTROUTE_CENTRE:
            return {
                ...state,
                centre: action.centre
            };
        case types.UPDATE_DRAFTROUTE_CREATEMODE:
            return {
                ...state,
                createMode: action.createMode
            }
        case types.UPDATE_DRAFTROUTE_PLOTMODE:
            console.log('erm: ' + action.plotMode)
            return {
                ...state,
                plotMode: action.plotMode
            }
        case types.UPDATE_DRAFTROUTE_AUTOMODE:
            return {
                ...state,
                autoMode: action.autoMode
            }
        case types.SET_RECENTREONLOAD:
            return {
                ...state,
                reCentreOnLoad: action.value
            }
        case types.SET_DRAFTROUTE_EDIT_ID:
            return {
                ...state,
                routeId: action.details.id,
                routeName: action.details.name
            }
        case types.CLEAR_DRAFTROUTE_EDIT_ID:
            return {
                ...state,
                routeId: null,
                routeName: null
            }
        case types.CLEAR_DRAFTROUTE_STATE:
            return initialState.routeCreatorState;
        case types.LOGOUT_SUCCESS:
            return initialState.routeCreatorState;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/routeCreatorStateReducer.js